import PropTypes from 'prop-types'
import { CaretRight } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { smileyResponse, thumbsResponse, prepareAnswers } from './helpers'
const SmsPreview = ({ buildingName, subtype, question }) => {
  const { t } = useTranslation(['surveys'])
  const answers = prepareAnswers(t, subtype)
  const prepareAnswerLength = () => {
    switch (subtype) {
      case smileyResponse:
        return 4
      case thumbsResponse:
        return 2
      default:
        return 5
    }
  }

  return (
    <div className="sms-preview">
      <div className="sms-preview__text">
        {buildingName} <CaretRight size={10} />
      </div>
      <div className="sms-preview__message">
        {t('surveys:preview.smsMessage', { question, max: prepareAnswerLength() })}
        <div>
          {answers.map((answer, index) => (
            <div key={answer}>
              {index + 1} - {answer}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

SmsPreview.propTypes = {
  buildingName: PropTypes.string,
  subtype: PropTypes.string,
  question: PropTypes.string,
}

export default SmsPreview
